// src/lib/brand-kit/applyBrandKitPreviewLayout.ts
import { applyLayoutBinds, type LayoutFieldBinds } from '@/lib/layouts/layoutFieldBinds';
import type { PostLayoutConfig } from '@/lib/layouts/types';

/** Overlay sample clip-title binds for template card/editor previews.
 *  Does not mutate stored layout data. */
export function applyBrandKitPreviewLayout(
  layout: PostLayoutConfig | null,
  fieldBinds: LayoutFieldBinds,
  sampleClipTitle: string,
  identity?: { userName?: string; userAvatarUrl?: string },
): PostLayoutConfig | null {
  if (!layout) return null;
  return applyLayoutBinds(layout, fieldBinds, {
    clipTitle: sampleClipTitle,
    userName: identity?.userName,
    userAvatarUrl: identity?.userAvatarUrl,
  });
}
